<div class="buttonbar-view">
  <material-inventory-navigation [article]="currentArticle"
    [variation]="currentVariation"
    (updateEmitter)="getLists()">
  </material-inventory-navigation>
</div>

<div class="row">
  <div class="col-sm-12">
    <h3>
      {{currentVariation.variation_id}} -
      {{currentArticle.name}} -
      Art. Nr. Lieferant: {{currentVariation.vendor_article_id}}
    </h3>
    <div>
      Gruppe: {{currentGroup.name}}
    </div>

    <div>
      <material-inventory-field-switch [fieldValues]="currentAggregation.article_fields">
      </material-inventory-field-switch>
    </div>
    <div>
      <material-inventory-field-switch [fieldValues]="currentAggregation.variation_fields">
      </material-inventory-field-switch>
    </div>
  </div>
  <div class="col-sm-12">
    &nbsp;
  </div>
  <div class="col-sm-12">
    &nbsp;
  </div>
</div>


@if (currentInventory) {
  <div class="row">
    <div class="col-sm-12">
      <h3>
        Lagerbestand
        <button class="btn btn-link"
          [ngbTooltip]="'Nullbestände ' + (showAll ? 'ausblenden' : 'einblenden')"
          (click)="toggleShowAll()">
          <i class="fa" [ngClass]="{'fa-eye': showAll, 'fa-eye-slash': !showAll}">
          </i>
        </button>
      </h3>
      <table class="table whitetable">
        <thead>
          <tr>
            <th>Lagerplatz</th>
            <th colspan="2">Wareneingang</th>
            <th class="align-right" style="width: 170px;">
              <div ngbTooltip="Anzahl der Ware, die am selben Tag und unter gleicher Chargennummer eingebucht wurde">
                Menge Wareneingang
              </div>
            </th>
            @if (('material.order.show.transaction.links'|HasPerm)) {
              <th class="icon"></th>
            }
            <th>Chargennummer</th>
            @if (('material.order.price.check'|HasPerm)) {
              <th class="align-right">Einzelpreis</th>
            }
            @if (currentArticle.konsi) {
              <th class="align-right" colspan="2">Konsi Bestand</th>
            }
            @if (currentArticle.konsi) {
              <th class="align-right" colspan="2">Eigen Bestand</th>
            }
            <th class="align-right" [colSpan]="currentArticle.konsi ? 1 : 2">Gesamt Bestand</th>
            <th>Einheit</th>
            @if (('material.order.price.check'|HasPerm)) {
              <th class="align-right">Materialwert</th>
            }
            @if (currentGroup.has_expiration) {
              <th>Haltbar bis</th>
            }
            <th>
              <material-label-print-button [variationId]="currentVariation.id" classInner="fa-2x">
              </material-label-print-button>
            </th>
          </tr>
        </thead>
        <tbody>
          @for (storage of currentInventory; track trackByFn(index, storage); let index = $index) {
            <tr
              [material-inventory-storage-row]="storage"
              [material-inventory-storage-row-has-expiration]="currentGroup.has_expiration"
              [material-inventory-storage-row-variation]="currentVariation"
              (material-inventory-storage-row-update)="getLists()">
            </tr>
          }
        </tbody>
        <tfoot>
          <tr>
            <td colspan="4"></td>
            @if (('material.order.show.transaction.links'|HasPerm)) {
              <td class="icon"></td>
            }
            <td></td>
            @if (('material.order.price.check'|HasPerm)) {
              <td class="align-right"></td>
            }
            @if (currentArticle.konsi) {
              <td class="align-right">{{totalAmount.konsi | money}}</td>
            }
            @if (currentArticle.konsi) {
              <td></td>
            }
            @if (currentArticle.konsi) {
              <td class="align-right">{{totalAmount.storage | money}}</td>
            }
            @if (currentArticle.konsi) {
              <td></td>
            }
            <td class="align-right">{{totalAmount.amount | money}}</td>
            @if (!currentArticle.konsi) {
              <td></td>
            }
            <td>{{currentVariation?.unit}}</td>
            @if (('material.order.price.check'|HasPerm)) {
              <td class="align-right">
                {{totalAmount.priceTotal|money:2}}&nbsp;&euro;
              </td>
            }
            @if (currentGroup.has_expiration) {
              <td></td>
            }
            <td class="icon"></td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
}

@if ('material.order.view'|HasPerm) {
  <material-article-order-list [variation]="currentVariation">
  </material-article-order-list>
}

<div class="row"><div class="col-sm-12">&nbsp;</div></div>
<div class="row"><div class="col-sm-12">&nbsp;</div></div>

@if (transactionLister.data$ | async; as transactions) {
  <material-inventory-transaction-list [currentArticle]="currentArticle"
    [currentVariation]="currentVariation"
    [currentTransactionList]="transactions"
    >
  </material-inventory-transaction-list>
} @else {
  <ng-template [ngTemplateOutlet]="loadingOrError.template"></ng-template>
}

<loading-or-error #loadingOrError
  [loadingWrapper]="transactionLister"
  [errorMessage]="'Konnte Bestandsverlauf nicht laden'">
</loading-or-error>
